// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2":"bb24451e","388":"bb24451e","841":"bb24451e","885":"bb24451e"}[chunkId] + ".chunk.css";
};